import React, { useCallback } from 'react';
import { AiFillCheckCircle, AiOutlinePlusCircle } from 'react-icons/ai';
import {
  isCompanyFollowingNonProfit,
  isFollowingNonProfit,
  toggleFollowNonProfit,
} from '../../stores/userActions';
import useConfirmDialogStore from '../Dialogs/confirmDialog.store';
import StyledFollowButton from './StyledFollowButton';
import { cva, cx } from 'cva';

const followNonProfitButton = cva('follow-non-profit-button', {
  variants: {
    size: {
      xs: ['w-4 h-4'],
      sm: ['w-6 h-6'],
      md: ['w-9 h-9'],
      lg: ['w-12 h-12'],
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

function FollowNonProfitButton(props) {
  const {
    nonProfit = null,
    onToggle = () => {},
    noConfirmation = false,
    type = 'plus',
    size,
    revalidate = () => {},
    excludeCompanyFollowing = false,
    className = 'text-primary',
  } = props;

  const iconStyles = followNonProfitButton({ size });

  const [isFollowing, setIsFollowing] = React.useState(false);
  const [busy, setBusy] = React.useState(false);
  const [disabled, setDisabled] = React.useState(false);
  const { seekConfirmation } = useConfirmDialogStore();

  const checkFollowing = useCallback(
    () =>
      nonProfit
        ? isFollowingNonProfit(nonProfit.id, excludeCompanyFollowing)
        : false,
    [nonProfit, excludeCompanyFollowing],
  );

  React.useEffect(() => {
    const following = checkFollowing();
    setIsFollowing(following);
    if (!excludeCompanyFollowing && following) {
      setDisabled(isCompanyFollowingNonProfit(nonProfit.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkFollowing, excludeCompanyFollowing]);

  const handleClick = async (e) => {
    // if (type === 'check' || type === 'plus') {
    //   setButtonType(buttonType === 'plus' ? 'check' : 'plus');
    // }
    e.preventDefault();
    e.stopPropagation();
    if (!busy && !disabled) {
      const title = `Unfollow ${nonProfit.name}?`;
      const message =
        'Their activities will no longer show up in your home feed. You can still view their profile.';
      const shouldConfirm = !noConfirmation && isFollowing;
      const confirmed = await (shouldConfirm
        ? seekConfirmation(title, message, 'Unfollow')
        : true);
      if (confirmed) {
        // setBusy(true);
        // const promise = toggleFollowNonProfit(nonProfit.id);
        // setIsFollowing(checkFollowing());
        // const following = await promise;
        // setIsFollowing(following);
        // setBusy(false);
        // onToggle(following);
        setBusy(true);
        const following = await toggleFollowNonProfit(nonProfit.id);
        setIsFollowing(following); // Only this is needed
        setBusy(false);
        onToggle(following);
      }
    }
    revalidate();
  };

  if (type === 'plus') {
    const getTitle = (following, disabled) => {
      if (disabled) return 'Disabled';
      if (following) return 'Unfollow';
      return 'Follow';
    };

    return (
      <button
        onClick={handleClick}
        disabled={busy || disabled}
        title={getTitle(isFollowing, busy || disabled)}>
        {isFollowing ? (
          <AiFillCheckCircle
            className={cx(
              iconStyles,
              className,
              busy || disabled ? 'text-text-disabled' : '',
            )}
          />
        ) : (
          <AiOutlinePlusCircle className={cx(iconStyles, className)} />
        )}
      </button>
    );
  }

  return (
    <StyledFollowButton
      type="button"
      isFollowing={isFollowing}
      onClick={handleClick}
      disabled={busy || disabled}
    />
  );
}

export default React.memo(FollowNonProfitButton);
